import React, { PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';

import { SpinnerLoader } from 'common';
import { BOTTOM_BAR_HEIGHT } from 'constants/sizes';

import { Container, BottomBarContainer } from './styles';

interface Props {
  loading?: boolean;
  BottomBarComponent?: () => React.ReactNode;
}

export const PageLayout = ({
  loading,
  children,
  BottomBarComponent,
}: PropsWithChildren<Props>) => {
  const theme = useTheme();

  return (
    <Container
      style={{
        paddingBottom: Boolean(BottomBarComponent)
          ? `calc(${theme.padding.default} + ${BOTTOM_BAR_HEIGHT})`
          : theme.padding.biggest,
      }}
    >
      {loading ? <SpinnerLoader /> : children}
      {BottomBarComponent && (
        <BottomBarContainer>{BottomBarComponent()}</BottomBarContainer>
      )}
    </Container>
  );
};
